import {requirePermission} from '@/modules/auth/permissions'
import {LinkButton} from '@cypro/ui/components/ui/link-button'
import {useAppForm} from '@cypro/ui/integrations/form'
import {HStack} from '@chakra-ui/react'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'
import {LuPlus} from 'react-icons/lu'

export const Route = createFileRoute('/configuration/locations/')({
  beforeLoad: requirePermission('organisation.manage'),
  component: LocationsPage,
})

function LocationsPage() {
  const {t} = useTranslate('common')

  const form = useAppForm({defaultValues: {search: ''}})

  return (
    <>
      <HStack justifyContent="space-between" width="100%">
        <LinkButton to="/configuration/locations/new" marginY="1rem" disabled colorPalette="cyan" size="sm">
          <LuPlus />
          {t('add_new')}
        </LinkButton>

        <form onSubmit={e => e.preventDefault()}>
          <form.AppField name="search">{field => <field.Searchbox />}</form.AppField>
        </form>
      </HStack>

      <div>table</div>
    </>
  )
}
